import Badge from "@mui/material/Badge";
import Tabs from "@mui/material/Tabs";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXTextField, withExplicitProps } from "./base.styles";
export const mobilePageMaxWidth = 480;
export const mobilePageHPadding = 32;
export const Parent = styled(FlexColumnDiv) `
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
    margin-top: ${(props) => { var _a; return (_a = props.marginTop) !== null && _a !== void 0 ? _a : 24; }}px;
`;
export const MainImage = styled.img `
    display: block;
    object-fit: contain;
    border-radius: 4px;
    padding: 16px ${mobilePageHPadding}px;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
`;
export const HXMobilePageTitleText = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    font-size: ${fontSizes.MOBILE_TITLE};
    line-height: 36px;

    ${(props) => props.center &&
    css `
            text-align: center;
        `}
`;
export const ContentContainer = styled(FlexColumnDiv) `
    align-self: stretch;
    padding: 0 ${(props) => { var _a; return (_a = props.horizontalPadding) !== null && _a !== void 0 ? _a : mobilePageHPadding; }}px 24px
        ${(props) => { var _a; return (_a = props.horizontalPadding) !== null && _a !== void 0 ? _a : mobilePageHPadding; }}px;
    align-items: ${(props) => (props.centerItems === true ? "center" : "flex-start")};
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 16; }}px;
    flex: 1 0 0;
`;
export const ContentContainerWithMainImage = styled(ContentContainer) `
    align-self: stretch;
    padding: 0 ${mobilePageHPadding}px;
    flex: 0;
`;
export const TextContainer = styled(FlexColumnDiv) `
    align-self: stretch;
    align-items: flex-start;
    gap: 16px;
`;
export const Subtitle = styled.div `
    color: ${colors.black_main};
    font-size: ${(props) => (props.fontSize ? props.fontSize : fontSizes.STANDARD)};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const BoldSubtitle = styled(Subtitle) `
    font-weight: ${fontWeights.BOLD};
`;
export const TinySubtitle = styled(Subtitle) `
    font-size: ${fontSizes.TINY};
    letter-spacing: 0.14px;
`;
export const LightSubtitle = styled(Subtitle) `
    color: ${colors.black_light};
`;
export const InlineSubtitle = styled(Subtitle) `
    display: inline;
`;
export const BoldInlineSubtitle = styled(InlineSubtitle) `
    font-weight: ${fontWeights.BOLD};
`;
export const Text = styled.div `
    color: ${(props) => `${props.color ? `${props.color}` : `${colors.black_main}`}`};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;

    ${(props) => props.center &&
    css `
            text-align: center;
        `}

    ${(props) => props.grow &&
    css `
            flex: 1 0 0;
        `}

    ${(props) => props.preWrap &&
    css `
            white-space: pre-wrap;
        `}
`;
export const TextBold = styled(Text) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const TextPreWrap = styled(Text) `
    white-space: pre-wrap;
`;
export const TextPreWrapBold = styled(TextBold) `
    white-space: pre-wrap;
`;
export const LightText = styled(Text) `
    color: ${colors.black_light};
`;
export const LightTextBold = styled(LightText) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const LighterText = styled(Text) `
    color: ${colors.black_lighter};
`;
export const TinyText = styled(Text) `
    color: ${colors.black_light};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
`;
export const TinyTextLighter = styled(TinyText) `
    color: ${colors.black_lighter};
`;
export const BoldTinyText = styled(TinyText) `
    font-weight: ${fontWeights.BOLD};
`;
export const LittleText = styled(Text) `
    color: ${colors.black_light};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: normal;
`;
export const LighterLittleText = styled(LittleText) `
    color: ${colors.black_lighter};
`;
export const BoldLittleText = styled(LittleText) `
    font-weight: ${fontWeights.BOLD};
`;
export const SemiBoldLittleText = styled(LittleText) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const MailtoLink = styled.a `
    color: ${colors.navy_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
    overflow-wrap: break-word;

    ${(props) => props.isError &&
    css `
            color: ${colors.tulip_main};
        `}

    ${(props) => props.disableLink &&
    css `
            pointer-events: none;
        `}
`;
export const AnchorBlue = styled.a `
    color: ${colors.accents_sky};
    cursor: pointer;
    text-decoration: ${(props) => (props.underline ? "underline" : "none")};
`;
export const BoldMailtoLink = styled(MailtoLink) `
    font-weight: ${fontWeights.BOLD};
`;
export const TinyMailtoLink = styled(MailtoLink) `
    font-size: ${fontSizes.TINY};
`;
export const TelephoneLink = styled(MailtoLink) ``;
export const MobileSubTabs = styled(Tabs).attrs({ centered: true }) `
    padding: 0 16px 16px 16px;
    align-self: stretch;
    width: auto;

    button {
        position: relative;

        &::after {
            content: "";
            border-bottom: 1px solid ${colors.black_12};
            position: absolute;
            bottom: 0;
            left: 0px;
            right: 0px;
        }
    }
`;
export const ListContainer = styled(FlexColumnDiv) `
    align-items: flex-start;
    align-self: stretch;
    padding: 0;
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 16; }}px;
`;
export const ListRow = styled(FlexRowDiv) `
    align-items: flex-start;
    padding: 0;
    gap: 8px;
`;
export const CenteredListRow = styled(ListRow) `
    align-items: center;
`;
export const HXMobilePageWithFixedHeaderAndFooterContainer = styled(FlexColumnDiv) `
    height: 100%;
    overflow-y: ${(props) => (props.overflowYHidden ? "hidden" : "visible")};
    align-self: stretch;
`;
export const HXMobilePageWithFixedHeaderAndFooterContent = styled(FlexColumnDiv) `
    flex: 1;
    overflow: ${(props) => (props.isHeaderAndFooterFixed ? "auto" : "visible")};
    align-self: stretch;

    ${(props) => props.fullHeight &&
    css `
            height: 100%;
        `}
`;
export const HXMobileTabBadge = styled(Badge) `
    position: absolute;
    top: 9px;
    margin-left: 10px;
    width: 8px;
    height: 8px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${colors.accents_sunset};
    border-radius: 100px;
`;
export const MarkdownContainer = styled(FlexColumnDiv) `
    padding: 0;
    align-items: flex-start;
    gap: 16px;
`;
export const MarkdownText = styled(Text) ``;
export const MobileTitle = styled.div `
    color: ${colors.black_main};
    text-align: center;
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 36px;
`;
export const MobileFormLabel = withExplicitProps(styled.div, "required", "error") `
    aling-self: stretch;
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;

    ${(props) => props.required &&
    css `
            &::after {
                content: " *";
                color: ${colors.tulip_main};
            }
        `}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}
`;
export const MobileCharacterCountText = styled(TinyText) `
    padding-left: 14px;
    color: ${(props) => (props.hasError ? colors.chips_tulip : colors.black_lighter)};
`;
export const MobileTextField = styled(HXTextField) `
    align-self: stretch;

    & .MuiOutlinedInput-root {
        fieldset {
            border-radius: 12px;
            border-color: ${colors.blue_30};
        }

        &.Mui-focused fieldset {
            border-color: ${colors.blue_main};
        }

        &.Mui-error fieldset {
            border-color: ${colors.tulip_main};
        }

        &:hover fieldset {
            border-color: ${colors.blue_50};
        }

        ${(props) => props.multiline
    ? css `
                      padding: 16px 20px;
                  `
    : css `
                      height: 48px;
                  `}
    }

    & .MuiInputBase-input.Mui-disabled {
        -webkit-text-fill-color: unset;
        color: ${colors.black_30};
    }

    & .MuiFormHelperText-root {
        line-height: 100%;
        font-size: ${fontSizes.LITTLE};
    }
`;
